var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnabled(_vm.aboutType))?_c('div',{staticClass:"container"},[_c('b-message',{attrs:{"title":"Что на этой странице?","type":"is-info"},on:{"close":function($event){return _vm.disable({type: _vm.aboutType})}}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }